import { Control, Controller } from 'react-hook-form';
import { timezones } from '../../../../utils/timezones';
import { RulesEngineFormValues } from '../rules-engine-form-page';
import ActionDescription from './action-description';

import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface ChangeCalendarTimezoneActionProps {
  description?: string;
  control: Control<RulesEngineFormValues>;
}

export default function ChangeCalendarTimezoneAction({
  control,
  description,
}: ChangeCalendarTimezoneActionProps) {
  return (
    <Stack>
      <ActionDescription description={description} />
      <Controller
        name="actionInfo.timeZone"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Time Zone"
            select
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              },
            }}
            fullWidth
          >
            {timezones.map((option) => (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </Stack>
  );
}
